module.exports = __webpack_public_path__ + "a46c6105c9278b686e74a38ed976e7d9.svg";